// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__3SYoN","errors":"Errors_errors__3mOz4"};